import { CSSProperties, ReactElement, useEffect, useState } from "react";
import { IField14Type, IPanelProps, ISystemEnum } from "./types";
import { cloneObject } from "../../../../../system/utils";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { Checkbox, MenuItem, Paper } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useFetch } from "../../../../../system/useFetch";
import Select from "@mui/material/Select";

const heatGridStyle = {
  gridTemplateColumns: "30px 1fr 1fr 1fr 70px"
};

const titleCellStyle = (): CSSProperties => ({
  padding: ".5em",
  alignSelf: "stretch",
  borderRadius: 5,
  background: "rgba(50, 50, 50, .3)"
});


const HSSPanel = ({ value, property, onChange }: IPanelProps<IField14Type[]>): ReactElement => {
  const [ checked, setChecked ] = useState<number[]>([]);
  const { data: products } = useFetch<ISystemEnum | null>({
    module: "system",
    query: "getSystemEnum",
    payload: { name: "RM_PRODUCTS" }
  });


  useEffect(() => {
    if (!value) {
      onChange(property, []);
    }
  }, [value, property, onChange]);

  const onChecked = (index: number, isChecked: boolean) => {
    if (isChecked) {
      setChecked([...checked, index]);
    } else {
      setChecked(checked.filter(x => x !== index));
    }
  };

  const onAddNewItem = () => {
    const newObj = cloneObject(value ?? []);
    newObj.push({ nose: 0, tail: 0, lost: 0 });

    onChange(property, newObj);
    setChecked([]);
  };

  const onRemoveSelectedHeats = () => {
    const newObj = cloneObject(value);

    checked.sort((a, b) => b - a)
      .forEach(index =>  {
        newObj.splice(index, 1);
    });

    onChange(property, newObj);
    setChecked([]);
  };


  const onChangeItem = (index: number, prop: keyof IField14Type, newValue: any) => {
    const newObj = cloneObject(value ?? []) as IField14Type[];

    if (prop === "product") {
      newObj[index].product = products?.values.find(x => x.value === newValue);
    } else {
      newObj[index][prop] = Number(newValue);
    }

    onChange(property, newObj);
  };

  return (
    <div className="display-flex-column gap-1">
        <div className="display-grid gap-1" style={heatGridStyle}>
          <Paper elevation={0}  style={titleCellStyle()} className="display-grid">
            <div />
          </Paper>
          <Paper elevation={0}  style={titleCellStyle()} className="display-grid">
            <div className="align-self-center justify-self-center display-flex-column">
              <strong>Product</strong>
            </div>
          </Paper>
          <Paper elevation={0}  style={titleCellStyle()} className="display-grid">
            <div className="align-self-center justify-self-center display-flex-column">
              <strong>Nose ring trims</strong>
            </div>
          </Paper>
          <Paper elevation={0}  style={titleCellStyle()} className="display-grid">
            <div className="align-self-center justify-self-center display-flex-column">
              <strong>Tail ring trims</strong>
            </div>
          </Paper>

          <div className="display-flex-row gap-1" >
            <IconButton size={"small"}  color="success" onClick={onAddNewItem}>
              <AddCircleOutlineIcon/>
            </IconButton>
            <IconButton size={"small"}  color="error" onClick={onRemoveSelectedHeats} disabled={checked.length === 0}>
              <DeleteIcon/>
            </IconButton>
          </div>
        </div>

        { value && value.map((item, index) => {

          return (
          <div key={`hss-${index}`} className="display-grid gap-1" style={heatGridStyle}>
            <Checkbox
              checked={checked.includes(index)}
              onChange={(_event, isChecked) => onChecked(index, isChecked)}/>
            <Select
              value={item.product ? item.product.value : 0}
              onChange={event => onChangeItem(index, "product", event.target.value)}
              displayEmpty
              fullWidth={true}>
              <MenuItem value={0}>None</MenuItem>
              {products && products.values.map(product => (
                <MenuItem key={product.name} value={product.value}>{product.name}</MenuItem>
              ))}
            </Select>

            <TextField
              variant="outlined"
              placeholder="to be filled..."
              type="number"
              value={item.nose}
              fullWidth={true}
              onChange={event => onChangeItem(index, "nose", event.target.value)}
            />
            <TextField
              variant="outlined"
              placeholder="to be filled..."
              type="number"
              value={item.tail}
              fullWidth={true}
              onChange={event => onChangeItem(index, "tail", event.target.value)}
              />
              <div/>
            </div>
          );
        })}
    </div>
  );
};

export default HSSPanel;